import { FC, memo, useCallback } from "react";

import { useAppDispatch } from "@/hooks/redux";
import { ProductCardWithCounterUI } from "@/pages/WorkPlan/Tasks/components/ProductCardWithCounterUI";
import { patchUpdateProductBalancesInventory } from "@/store/slices/progress";

interface InventoryProductCardProps {
    barcode: string;
    name: string;
    taskId: string;
    remainingCounter?: number;

    isLast: boolean;
    onView: () => void;
}

export const InventoryProductCard: FC<InventoryProductCardProps> = memo(
    ({ barcode, name, taskId, remainingCounter, isLast, onView }) => {
        const dispatch = useAppDispatch();

        const handleAddInventory = useCallback(() => {
            dispatch(
                patchUpdateProductBalancesInventory({
                    barcode,
                    count: 1,
                    taskId,
                }),
            );
        }, [dispatch, barcode, name, taskId]);

        const handleInventoryCountChange = useCallback(
            (count: number) => {
                dispatch(
                    patchUpdateProductBalancesInventory({
                        taskId,
                        barcode,
                        count,
                    }),
                );
            },
            [dispatch, taskId, barcode],
        );

        const isAddMode = !(
            typeof remainingCounter === "number" && remainingCounter > 0
        );

        return (
            <ProductCardWithCounterUI
                name={name}
                barcode={barcode}
                {...(isAddMode
                    ? {
                          counterType: "add" as const,
                          onAddTouchStart: handleAddInventory,
                      }
                    : {
                          counterType: "counter" as const,
                          counterValue: remainingCounter!,
                          onCounterChange: handleInventoryCountChange,
                      })}
                isLast={isLast}
                onView={onView}
            />
        );
    },
);

InventoryProductCard.displayName = "InventoryProductCard";
